export default __webpack_public_path__ + "static/media/tokenomics.a7f40088.svg";